import { render, staticRenderFns } from "./TableListProducts.vue?vue&type=template&id=bff82e82&"
import script from "./TableListProducts.vue?vue&type=script&lang=js&"
export * from "./TableListProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bff82e82')) {
      api.createRecord('bff82e82', component.options)
    } else {
      api.reload('bff82e82', component.options)
    }
    module.hot.accept("./TableListProducts.vue?vue&type=template&id=bff82e82&", function () {
      api.rerender('bff82e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rawmaterials/TableListProducts.vue"
export default component.exports